import React from "react";
import { Typography, Divider } from "@material-ui/core";
import Link from "@material-ui/core/Link";
// import ReactPlayer from "react-player";

export default props => (
  <div>
    {/* <Typography variant="h5" color="primary" component="h2">
      Schematic
    </Typography> */}
    <div style={{ textAlign: "center" }}>
      <img
        style={{ borderRadius: "8px", border: "1px solid gray" }}
        src="./Schematic1.jpg"
        alt="Schematic"
        width="50%"
      />
    </div>
    <Divider />
    <br />
    <Typography variant="h5" color="primary" component="h2">
      What does it do?
    </Typography>
    <p>
      This device uses multiple MQ Gas Sensors to estimate different pesticide
      presence by relying on Machine Learning Models.
    </p>
    <Divider />
    <br />
    <Typography variant="h5" color="primary" component="h2">
      Who's done what beforehand?
    </Typography>
    <ul>
      <li>
        <Link color="secondary"
          target="_blank"
          href={
            "https://www.researchgate.net/publication/307608992_Detection_of_pesticide_in_fruits_using_an_electronic_nose"
          }
        >
          Detection of pesticide in fruits using an electronic nose
        </Link>
      </li>
      <li>
        <Link color="secondary"
          target="_blank"
          href={
            "https://phys.org/news/2016-07-electronic-nose-pesticides-nerve-gas.html"
          }
        >
          Electronic nose smells pesticides and nerve gas
        </Link>
      </li>
      <li>
        <Link color="secondary"
          target="_blank"
          href={
            "https://www.researchgate.net/publication/304408390_Detection_of_pesticide_in_the_vesca_fregaria_through_an_electronic_nose"
          }
        >
          Detection of pesticide in the vesca fregaria through an electronic
          nose
        </Link>
      </li>
      <li>
        <Link color="secondary"
          target="_blank"
          href={
            "https://www.researchgate.net/publication/328476031_Wireless_Electronic_Smell_System_for_the_Detection_of_Diseases_Through_the_Exhaled_Breath"
          }
        >
          Wireless Electronic Smell System for the Detection of Diseases Through
          the Exhaled Breath
        </Link>
      </li>
    </ul>
    <Divider />
    {/* <div align="center" className="player-wrapper">
      <ReactPlayer
        url="https://www.youtube.com/watch?v=IRGB-XG0evk"
        width="100%"
        height="100%"
        controls
      />
    </div> */}
    <Divider />
    <br />
    <Typography variant="h5" color="primary" component="h2">
      Who will use it?
    </Typography>
    <p>
      This device has range of users like organic farm produce sellers, buyers.
    </p>
  </div>
);
